export const DISCOUNT_TYPE = {
  AMOUNT: 'AMOUNT',
  PERCENT: 'PERCENT'
};

export const MAX_DECIMAL_DIGITS_IN_DISCOUNT = 4;
